import { LoadingModule } from 'app/main/components/general/loading/loading.module';
import { InsectDetectionDataComponent } from './insect-detection-data.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatSortModule } from '@angular/material/sort';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [InsectDetectionDataComponent],
  imports: [
    PerfectScrollbarModule,
    MatFormFieldModule,
    FuseSharedModule,
    MatDialogModule,
    TranslateModule,
    MatButtonModule,
    MatInputModule,
    MatMenuModule,
    MatSortModule,
    LoadingModule,
    MatIconModule,
    ChartsModule
  ],
  exports: [InsectDetectionDataComponent],
})

export class InsectDetectionDataModule { }
